/**
 * The navigation model.
 *
 * One list drives the sidebar, the mobile nav and the route guards. Each item
 * carries the permission it needs, so a viewer's sidebar and a viewer's
 * routing agree by construction rather than by two people remembering to edit
 * both.
 */
export const NAV_SECTIONS = [
  {
    id: 'operate',
    label: 'Operate',
    items: [
      { to: '/', label: 'Dashboard', icon: 'dashboard', end: true, permission: 'vehicle:read' },
      { to: '/vehicles', label: 'Vehicles', icon: 'truck', permission: 'vehicle:read' },
      { to: '/alerts', label: 'Alerts', icon: 'bell', permission: 'alert:read', badge: 'alerts' },
    ],
  },
  {
    id: 'analyse',
    label: 'Analyse',
    items: [
      { to: '/analytics', label: 'Analytics', icon: 'chart', permission: 'analytics:read' },
      { to: '/devices', label: 'Devices', icon: 'chip', permission: 'device:read' },
      { to: '/firmware', label: 'Firmware', icon: 'download', permission: 'device:read' },
    ],
  },
  {
    id: 'administer',
    label: 'Administer',
    items: [
      { to: '/admin', label: 'Administration', icon: 'users', permission: 'user:read' },
      { to: '/platform', label: 'Platform', icon: 'building', permission: 'org:write' },
      { to: '/audit', label: 'Audit log', icon: 'shield', permission: 'audit:read' },
    ],
  },
  {
    id: 'you',
    label: 'You',
    items: [
      // No permission: everyone has a password to change and access to ask for.
      { to: '/settings', label: 'Settings', icon: 'sun' },
    ],
  },
];

/** The sections a given permission set can actually see. */
export function visibleSections(can) {
  return NAV_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter((item) => !item.permission || can(item.permission)),
  })).filter((section) => section.items.length > 0);
}
